module.exports = __webpack_public_path__ + "img/28.b5506e7a.jpg";